<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Inventory" | tenantWords}} Batches</h2>
      <span class="page-subtitle">Printed tag batches by lot and work order</span>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="exportExcel()">
        <fa-icon [icon]="faFileExcel" class="me-2"></fa-icon>Export
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <div class="search-box">
      <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
      <input type="text" placeholder="Search by lot, {{'product' | tenantWords}}, work order type, or creator..."
        [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()" class="search-input" aria-label="Search batches">
    </div>
  </div>

  <div class="grid-card">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.rows" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings" [allowTextWrap]="true"
      [enableStickyHeader]="true" [enableHover]="true" [allowExcelExport]="true"
      (dataBound)="onDataBound()" (rowSelected)="onRowSelected($event)">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow" (click)="openActions(row)">
      <div class="m-card-top">
        <span class="m-card-name">{{"Lot" | tenantWords}} {{row.lotNumber || '—'}}</span>
        <span class="type-pill">{{row.availableQuantity | number}} available</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="row.itemName">
          <fa-icon [icon]="faBox" class="m-meta-icon"></fa-icon>{{row.itemName}}
        </div>
        <div class="m-meta-line" *ngIf="row.createdBy">
          <fa-icon [icon]="faUser" class="m-meta-icon"></fa-icon>{{row.createdBy}}
        </div>
        <div class="m-meta-line" *ngIf="row.createdDateObj">
          <fa-icon [icon]="faCalendar" class="m-meta-icon"></fa-icon>{{row.createdDateObj | date:'MM/dd/yyyy'}}
        </div>
      </div>

      <div class="m-card-foot">
        <ng-container *ngTemplateOutlet="typeTemplate; context: { $implicit: row }"></ng-container>
        <div class="m-card-actions">
          <button mat-icon-button aria-label="Batch actions" (click)="openActions(row); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faTags" class="m-empty-icon"></fa-icon>
      <div>No batches match your search</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #typeTemplate let-data>
  <span *ngIf="data.workOrderType; else noType" class="status-tag wo-type" [style.color]="data.workOrderTypeColor">
    <span class="status-dot"></span>{{data.workOrderType}}
  </span>
  <ng-template #noType><span class="type-pill empty">—</span></ng-template>
</ng-template>

<ng-template #actionTemplate let-data>
  <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
</ng-template>
